// MyScreen.tsx — 솟다 MY 탭 본 화면 (클로드디자인 교체)
// extras.jsx PageMyPage 이식 — status bar·고정 height·CSBottomNav 제거, 솟다 TabLayout이 셸 제공.
// 프로필·BULL 경제·등급 진척·설정 메뉴 = 시안 정적값 (MY 탭 API 미보유, 추후 배선).
// design doc: 2026-05-22-sotda-ia-restructure §4 Phase E
// @ts-nocheck
import '../cs-tokens.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { CSCard, CSBtn, CSRow, CSAppBar, CSIconBtn, CSIcon, CSModal } from '../_components/cs';
import { getBlockedAuthors, getBlockedList, unblockAuthor } from '../../data-access/blockListAdapter';
import { getUnreadMessageCount } from '../../data-access/messagesAdapter';
import { CastPortrait, CAST } from '../_components/cast';
import { GRADE_META } from '@core/sim/cosmetic/cosmeticCatalog';
import { EquippedCosmeticMini } from '../_components/SocialCosmetic';
import { useEquippedCompanion } from '../../hooks/useEquippedCompanion';
import { supabase } from '../../lib/supabase';
import { unregisterPushToken } from '../../lib/push';
import { apiFetch } from '../../lib/api';
import { useAuth } from '../../lib/useAuth';
import { useMe } from '../../lib/useMe';
import { CHALLENGE_TRACKS, DEFAULT_TRACK } from '@core/economy/challengeTracks';
import { useMyChallenge } from '../../hooks/useChallenge'; // 행동 챌린지(6엔진 Step 6) 진행/이력 인덱스
import { useReviewAuto } from '../../hooks/useReviewAuto'; // 자동 복기 설정 진입 행 노출 판정(자격 없으면 숨김)
import { useAchievementGallery } from '../../hooks/useAchievementGallery'; // 황소 컬렉션(업적) 획득/전체 — 2026-09-12
import { showInfo, showSuccess } from '../../lib/toast'; // 미배선 설정 메뉴 "준비 중" 피드백 (dead-end 해소, 2026-07-01)
import { useAppVersion } from '../../lib/appMeta'; // 표시 버전 단일 출처 (네이티브=App.getInfo · 문의 메일과 동일 값)
import { DeleteAccountSheet } from './DeleteAccountSheet'; // 앱 내 계정 삭제 (App Store 5.1.1(v))
import { NicknameSheet } from './NicknameSheet'; // 닉네임 변경 (change_nickname RPC · 2026-08-12)

// 숫자 천단위 콤마 (미로딩 시 0)
const won = (n) => (n ?? 0).toLocaleString('ko-KR');

// 설정 메뉴 — 라우트 미배선 항목은 "준비 중" 토스트로 피드백 (탭해도 무반응 dead-end 해소, 2026-07-01)
// 2026-08-12: 프로필/닉네임(NicknameSheet)·도움말/문의(mailto)가 실작동으로 승격 → 설정 그룹으로 이동
const MENU = [
  { i: "bell", t: "알림 · 봇 구독", onClick: () => showInfo("알림·봇 구독 설정은 준비 중이에요") },
  { i: "eye", t: "공개 범위", onClick: () => showInfo("공개 범위 설정은 준비 중이에요") },
];

export function SotdaMyScreen() {
  // 2026-05-25: 로그아웃 UI 부활 (AccountStrip 죽은 코드 사고 후속).
  // 시안 친화 — MENU 배열은 정적 박제 유지, 끝에 동적 인증 항목 1개 합성.
  const navigate = useNavigate();
  const { user } = useAuth();
  // 내 장착 캐릭터(코스메틱 §14 nick_avatar) — 커뮤니티 목록·글 상세가 읽는 것과 같은 슬롯.
  //   예전엔 닉네임 첫 글자(CSAvatar)라 뽑기·장착을 해도 마이탭에선 확인할 곳이 없었다(2026-09-03 효신님).
  //   profile_character 슬롯은 아직 장착 UI가 없어 당분간 nick_avatar 하나로 두 자리(프로필·히어로)를 채운다.
  const companion = useEquippedCompanion(['nick_avatar']);
  // 기본 캐릭터(base_cast)·미장착은 커뮤니티와 동일하게 등급 오라 없이(grade null) 그린다.
  // ⚠ userLevel은 여기서 읽지 않는다 — `me` state가 이 아래에서 선언되어 TDZ(Cannot access 'me' before initialization)로
  //   마이탭 전체가 ErrorBoundary에 걸렸다(2026-09-03 SE3 실기·dev 재현). tsc는 TDZ를 못 잡는다. JSX에서 합성한다.
  const avatarCosmetic = { slug: companion.slug, grade: companion.cardId ? companion.grade : null, level: companion.level, unset: companion.isDefault };
  const heroCastId = CAST[companion.slug] ? companion.slug : 'hwangdoongi';
  // 🔴 2026-09-10: 장착 조회 전에는 companion이 기본값(황둥이·isDefault)이다. 그대로 그리면
  //   "황둥이·회색·고르기 배너 → 실제 캐릭터"로 깜빡였다(효신님 SE3). 첫 로드 동안은 캐릭터를 비워 둔다.
  //   재진입은 useEquippedCompanion 캐시로 즉시 뜨므로 이 분기는 첫 진입 한 번만 탄다.
  const castLoading = companion.isLoading;
  // 지금 무엇을 쓰고 있는지 한 줄로. 카드 장착이면 등급까지(카드는 등급이 곧 정체성이다).
  //   배너(b)·프로필 편집 시트(c) 두 곳이 같은 문장을 써야 "지금 상태"가 어긋나지 않는다.
  const companionSummary = companion.isDefault
    ? '아직 안 골랐어요 · 기본 11종은 무료'
    : `${CAST[companion.slug]?.ko || '황둥이'} · ${companion.cardId && companion.grade ? `${GRADE_META[companion.grade].label} 카드` : '기본 아바타'}`;
  const { data: me, isLoading } = useMe();
  const qc = useQueryClient();
  const { challenge } = useMyChallenge(); // 챌린지 진행 인덱스(6엔진 Step 6)
  const { data: reviewAuto } = useReviewAuto(); // entitled=false면 설정 행 자체를 숨긴다(2026-08-28 효신님 결정)
  const { data: achGallery, isError: achError } = useAchievementGallery(); // 황소 컬렉션 카드 획득/전체 (/collection과 캐시 공유)
  const chTrack = CHALLENGE_TRACKS[challenge?.track || DEFAULT_TRACK];
  // 진행 요약 카피 — 상태별 한 줄
  const chSummary = !challenge
    ? '참가 전 · 미션을 골라보세요'
    : challenge.status === 'active'
      ? `진행 중 · ${challenge.day_index}/7일 · 복기 ${challenge.progress_count}/${challenge.required_count}`
      : challenge.status === 'success'
        ? '완주 · 배지 + EXP'
        : '종료 · 조건 미충족';
  // me 로딩 중(로그인 상태)엔 빈 값 대신 스켈레톤 — prefetch 미스 시 깜빡임 보강
  const sk = isLoading && !!user;
  const Sk = ({ w = 48, h = 14 }) => (
    <span style={{ display: 'inline-block', width: w, height: h, borderRadius: 6, background: 'var(--cs-surface-2)', animation: 'csSkP 1.2s ease-in-out infinite', verticalAlign: 'middle' }}>&nbsp;</span>
  );
  // BULL 히어로 잔액 — 자릿수에 따라 폰트를 낮춰 한 줄을 유지한다.
  // 황둥이(130px)를 피한 가용 폭이 SE3에서 약 203pt고, 모노 숫자 한 글자가 대략 0.6em이라
  // 40px는 9자, 33px는 10자, 28px는 12자까지 들어간다. (2026-08-14 잔액 2줄 접힘 실측 후)
  // 2026-10-03 큰 숫자 = **활동 BULL**(bull − cash_bull). 약관상 BULL은 무상 지급분만이고,
  //   크레딧(cash_bull, 유상)은 모의투자 원금이 아니다. 전체 bull을 보여 주면 크레딧이 BULL처럼 읽힌다.
  //   모의투자 투자가능액(sim_buy)·EXP 교환 가능액(아래 activeBull)과 같은 숫자가 된다.
  const heroBull = Math.max(0, (me?.bull ?? 0) - (me?.cash_bull ?? 0));
  const creditBull = Math.max(0, me?.cash_bull ?? 0); // 0보다 클 때만 "크레딧 N 별도" 한 줄
  const bullText = won(heroBull);
  const bullFontSize = bullText.length >= 11 ? 28 : bullText.length >= 9 ? 33 : 40;

  // 계정 삭제 시트 (App Store 5.1.1(v) — 앱 안에서 삭제를 시작할 수 있어야 한다)
  const [deleteOpen, setDeleteOpen] = useState(false);
  const appVersion = useAppVersion();
  // 빌드 정보(시각·세션 태그)는 **숨김이 기본** — 버전 줄을 5번 탭해야 보인다(2026-09-15 효신님).
  //   종전엔 조건 없이 그려서 스토어 빌드에도 "vigilant-je·458ba1" 같은 **내부 브랜치 이름이 실사용자에게** 찍혔다
  //   (스토어 빌드도 이 맥북 워크트리에서 만들고, 태그는 git 없는 환경에서만 빠진다).
  //   환경변수로 끄는 방식은 빌드하는 사람이 기억해야 안 새는 구조라 기각 — 기본 숨김이면 샐 여지가 없다.
  //   SE3 "지금 도는 게 내 빌드인가" 앵커(feedback_device_install_multi_session)는 5번 탭으로 유지된다.
  const [buildTaps, setBuildTaps] = useState(0);
  const showBuild = buildTaps >= 5;
  const tapVersion = () => setBuildTaps((n) => (n >= 5 ? n : n + 1));
  // 닉네임 변경 시트 (2026-08-12 — "준비 중"이던 프로필 편집 1차 배선)
  const [nickOpen, setNickOpen] = useState(false);
  // 프로필 편집 허브 — "편집"을 누른 사람이 캐릭터도 찾을 수 있게(외부 감사 가설: 아바타 변경을 '편집'에서 찾는다).
  const [editOpen, setEditOpen] = useState(false);
  // 차단한 사용자 관리 모달
  const [blockOpen, setBlockOpen] = useState(false);
  const [blockedList, setBlockedList] = useState([]);
  const [blockedCount, setBlockedCount] = useState(0); // 메뉴 노출 판단용 (0이면 메뉴 숨김)
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);
  useEffect(() => {
    // 마운트 + 모달 닫을 때 + 계정 변경 시 차단 수 갱신 (해제 반영)
    getBlockedAuthors(user?.id).then((s) => setBlockedCount(s.size)).catch(() => {});
    if (!blockOpen) return;
    getBlockedList(user?.id).then(setBlockedList).catch(() => {});
  }, [blockOpen, user?.id]);
  useEffect(() => {
    let active = true;
    if (!user) {
      setUnreadMessageCount(0);
      return () => { active = false; };
    }
    getUnreadMessageCount()
      .then((count) => {
        if (active) setUnreadMessageCount(count);
      })
      .catch(() => {
        if (active) setUnreadMessageCount(0);
      });
    return () => { active = false; };
  }, [user?.id]);
  async function handleUnblock(id) {
    if (!user) return;
    await unblockAuthor(user.id, id);
    setBlockedList((prev) => prev.filter((b) => b.id !== id));
    setBlockedCount((c) => Math.max(0, c - 1));
  }

  // #7 BULL → EXP 전환 모달
  const [convOpen, setConvOpen] = useState(false);
  const [convAmt, setConvAmt] = useState(50);
  const [converting, setConverting] = useState(false);
  // null = 아직 모름/조회 실패. 200(풀 한도)을 초깃값으로 두면 조회가 실패해도
  //   "오늘 200 EXP 남음"으로 보여서 전환을 눌렀다가 서버에서 거부당한다 (2026-08-02 결정).
  const [dailyRem, setDailyRem] = useState<number | null>(null);
  const [convMsg, setConvMsg] = useState('');
  const activeBull = Math.max(0, (me?.bull ?? 0) - (me?.cash_bull ?? 0)); // 전환 가능 활동분(구매분 제외)
  // 한도를 모르면 전환을 열지 않는다 (0 → 버튼 비활성) — 거짓 한도로 시도시키지 않기 위해
  const maxConv = dailyRem == null ? 0 : Math.min(dailyRem, activeBull);
  // 모달 열 때 오늘 남은 한도 조회
  useEffect(() => {
    if (!convOpen) return;
    setConvMsg('');
    setDailyRem(null); // 열 때마다 초기화 — 이전 조회값이 남아 최신처럼 보이지 않게
    apiFetch('/api/mobile/level/convert-bull')
      .then((r) => setDailyRem(typeof r?.daily_remaining === 'number' ? r.daily_remaining : null))
      .catch(() => setDailyRem(null)); // 실패는 '—'로 — 풀 한도로 위장하지 않는다
  }, [convOpen]);
  const doConvert = async () => {
    if (converting || convAmt <= 0 || convAmt > maxConv) return;
    setConverting(true); setConvMsg('');
    try {
      const r = await apiFetch('/api/mobile/level/convert-bull', { method: 'POST', body: { amount: convAmt } });
      qc.invalidateQueries({ queryKey: ['me'] }); // BULL·등급 즉시 갱신
      setConvMsg(`✓ +${convAmt} EXP 적립${r?.leveled_up ? ` · Lv.${r.new_level} 달성 🎉` : ''}`);
      setDailyRem(r?.daily_remaining ?? dailyRem);
      setTimeout(() => setConvOpen(false), 1500);
    } catch (e) {
      let msg = '전환에 실패했어요';
      try { msg = JSON.parse(e?.body || '{}')?.message || msg; } catch { /* 기본 메시지 */ }
      setConvMsg(msg);
    } finally {
      setConverting(false);
    }
  };

  // 프로필 요약 3종 — 실데이터 (미로딩 시 placeholder)
  const profileStats = [
    { l: "머니타입", v: sk ? <Sk w={30} /> : (me?.mbti?.code || "—") },
    { l: "기록일수", v: sk ? <Sk w={36} /> : (me ? `${me.recordDays}일` : "—") },
    { l: "글", v: sk ? <Sk w={24} /> : (me ? String(me.postCount) : "—") },
  ];
  // 가입일 (ISO → YYYY.MM.DD), 닉네임
  const sinceLabel = me?.sinceDate ? me.sinceDate.slice(0, 10).replace(/-/g, ".") : "—";
  const nick = me?.nickname || user?.user_metadata?.nickname || "게스트";

  async function onLogout() {
    // 로그아웃 전 이 기기의 FCM 토큰 파기(개인정보 #3: 이후 이전 계정 알림 유입 차단)
    await unregisterPushToken();
    // signOut → onAuthStateChange가 useAuth 세션 null로 갱신 → user 분기 자동 전환
    await supabase.auth.signOut();
    // me(react-query) 캐시 제거 — 안 비우면 프로필·BULL·등급이 로그아웃 후에도 잔존 (정보 그대로 버그)
    qc.removeQueries({ queryKey: ['me'] });
    navigate('/'); // 홈으로 복귀
  }

  function onLogin() {
    navigate('/login');
  }

  // 로그인 시 "로그아웃" / 미로그인 시 "로그인" — 하나만 표시
  const authItem = user
    ? { i: 'info', t: '로그아웃', onClick: onLogout }
    : { i: 'user', t: '로그인', onClick: onLogin };
  // 앱 소개(/about) Phase B 진입점 — design doc §B 트랙 A
  const aboutItem = { i: 'book', t: '앱 소개', onClick: () => navigate('/about') };
  // 폐지수집소 — 파산 구제 (design doc §16-2)
  const scrapItem = { i: 'trash', t: '폐지수집소', onClick: () => navigate('/scrap') };
  // 차단한 사용자 관리 (App Store 1.2 — 차단 해제 경로)
  const blockItem = { i: 'eye', t: '차단한 사용자', onClick: () => setBlockOpen(true) };
  // 계정 연동 (네이버·카카오·구글·이메일 한 계정에 묶기) — 로그인 시만 (design doc 2026-06-16 §6)
  const accountLinkItem = { i: 'link', t: '계정 연동', onClick: () => navigate('/account-link') };
  // 프로필/닉네임 — change_nickname RPC 배선 (게스트는 로그인으로, 2026-08-12)
  const profileItem = { i: 'user', t: '프로필 / 닉네임', onClick: () => (user ? setNickOpen(true) : navigate('/login')) };
  // 자동 복기·자동 토론 설정 — 회당 500cb를 차감하는 기능이라 앱에 동의 화면이 필요했다 (2026-08-28)
  //   자격(허용리스트·국밥 티어) 없는 계정은 서버가 not_entitled로 걸러내므로 행을 아예 숨긴다.
  const reviewAutoItem = {
    i: 'refresh', t: '자동 복기 · 자동 토론',
    sub: reviewAuto?.schedule?.enabled
      ? `켜짐 · 매일 ${String(Math.floor(reviewAuto.schedule.run_minute_kst / 60)).padStart(2, '0')}:${String(reviewAuto.schedule.run_minute_kst % 60).padStart(2, '0')}${reviewAuto.schedule.debate_enabled ? ' · 토론 포함' : ''}`
      : '꺼짐',
    onClick: () => navigate('/review-auto'),
  };
  // 도움말/문의 — support@sotda.com. 버전·빌드를 본문에 실어 문의 대응 왕복을 줄인다 (appMeta 주석의 계획 실행)
  const helpItem = {
    i: 'info', t: '도움말 / 문의',
    onClick: () => {
      const subject = encodeURIComponent('[솟다 문의]');
      // 문의 메일엔 빌드 정보를 계속 넣는다 — 사용자가 직접 보내는 진단 정보라 노출이 아니라 지원용이다.
      const body = encodeURIComponent(`\n\n—\n앱 버전: ${appVersion} · 빌드 ${__BUILD_TIME__}`);
      // Capacitor는 mailto: 등 non-http 스킴을 OS로 넘긴다 — 메일 앱이 없으면 무반응이라 주소를 토스트로 병행 안내
      window.open(`mailto:support@sotda.com?subject=${subject}&body=${body}`);
      showInfo('문의: support@sotda.com');
    },
  };
  // 차단 메뉴 = 로그인 + 차단한 사용자 1명 이상일 때만 (게스트·빈 목록이면 숨김)
  // 설정 = 실작동 항목만 (CD MY탭: 준비중 항목은 아래 dim 그룹으로 분리)
  const settingMenu = [profileItem, scrapItem, ...(user ? [accountLinkItem] : []), ...(user && reviewAuto?.entitled ? [reviewAutoItem] : []), ...(user && blockedCount > 0 ? [blockItem] : []), aboutItem, helpItem, authItem];

  return (
    <div className="cs-root" data-density="regular" data-temp="warm" data-heading="serif"
         style={{ width: "100%", minHeight: "100%", position: "relative", background: "var(--cs-bg)" }}>
      <style>{`@keyframes csSkP{0%,100%{opacity:1}50%{opacity:.45}}`}</style>
      {/* status bar 제거 — iOS 실제 상태바 사용 */}
      <CSAppBar
        left={<span className="cs-italic" style={{ fontSize: 19 }}>마이</span>}
        title=""
        right={<><CSIconBtn label="쪽지함" onClick={() => navigate('/messages')}><span style={{ position: 'relative', display: 'inline-flex' }}><CSIcon name="bell" />{unreadMessageCount > 0 && <span aria-label={`읽지 않은 쪽지 ${unreadMessageCount}개`} style={{ position: 'absolute', top: -2, right: -3, width: 7, height: 7, borderRadius: 'var(--cs-r-pill)', background: 'var(--cs-accent)' }} />}</span></CSIconBtn><CSIconBtn label="더보기"><CSIcon name="more" /></CSIconBtn></>}
      />

      <div className="cs-stagger" style={{ padding: "4px 16px 16px" }}>
        {/* 프로필 카드 */}
        <CSCard padded style={{ padding: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            {/* ?focus=base — 캐릭터를 바꾸러 온 사람을 0/44 수집 표가 아니라 무료 선택기로 보낸다(2026-09-10) */}
            <button type="button" aria-label="내 캐릭터 바꾸기" onClick={() => navigate(user ? '/cards?focus=base' : '/login')}
              style={{ border: 0, background: "transparent", padding: 0, cursor: "pointer", display: "inline-flex" }}>
              {castLoading
                ? <span aria-label="캐릭터 불러오는 중" style={{ display: 'inline-block', width: 56, height: 56, borderRadius: '50%', background: 'var(--cs-surface-2)', animation: 'csSkP 1.2s ease-in-out infinite' }} />
                : <EquippedCosmeticMini cosmetic={{ ...avatarCosmetic, userLevel: me?.grade?.level ?? null }} size={56} />}
            </button>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 17, fontWeight: 700, letterSpacing: "-0.02em" }}>{sk ? <Sk w={90} h={18} /> : nick}</div>
              <div style={{ fontSize: 11.5, color: "var(--cs-mute)", marginTop: 2, fontFamily: "var(--cs-font-mono)" }}>since {sinceLabel} · D+{me?.dPlus ?? 0}</div>
            </div>
            {/* 2026-08-12: onClick 없던 데드 버튼 → 닉네임 변경 시트 배선 (게스트는 로그인으로) */}
            {/* 2026-09-10: 종전엔 닉네임 시트로 직행해 **캐릭터를 바꾸러 온 사람이 막혔다**.
                프로필 편집 시트(캐릭터·닉네임)를 거친다 — 닉네임 변경은 1탭 늘지만 자주 바꾸는 값이 아니다. */}
            <CSBtn variant="secondary" size="sm" onClick={() => (user ? setEditOpen(true) : navigate('/login'))}>편집</CSBtn>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginTop: 14 }}>
            {profileStats.map((b, i) => (
              <div key={i} style={{ padding: "8px 4px", background: "var(--cs-surface-2)", borderRadius: 10, textAlign: "center" }}>
                <div style={{ fontSize: 10.5, color: "var(--cs-mute)", fontWeight: 500 }}>{b.l}</div>
                <div className="num" style={{ fontSize: 14, fontWeight: 700, marginTop: 2 }}>{b.v}</div>
              </div>
            ))}
          </div>
          {/* 기본값 정책 ③(2026-09-03 효신님): 미장착이면 고를 때까지 황둥이 + 고르기 유도 1행.
              자동 배정(②)은 유저가 고른 적 없는 캐릭터가 대표로 뜨는 문제가 있어 기각. §G: 테두리 없이 배경 명도 대비만.
              🔴 2026-09-10 상시화: 종전엔 `companion.isDefault`일 때만 떠서 **한 번 고르면 사라졌고**, 그 뒤엔
              다시 바꿀 길이 사실상 숨었다(아바타 탭은 시각 단서 없음 · 하단 '카드 컬렉션'은 0/44 표로 떨어짐).
              정작 바꾸고 싶어질 때 말을 멈추던 것을, 상태별 문구로 계속 둔다. */}
          {!sk && !castLoading && user && (
            <button type="button" onClick={() => navigate('/cards?focus=base')}
              style={{ marginTop: 12, width: "100%", display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 12, background: "var(--cs-surface-2)", border: 0, textAlign: "left", cursor: "pointer", color: "inherit" }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12.5, fontWeight: 700 }}>{companion.isDefault ? '내 캐릭터 고르기' : '캐릭터 바꾸기'}</div>
                <div style={{ fontSize: 11, color: "var(--cs-mute)", marginTop: 1 }}>
                  {companion.isDefault ? '기본 11종은 무료 · 뽑은 카드는 등급 오라가 붙어요' : `지금 ${companionSummary}`}
                </div>
              </div>
              <CSIcon name="arrow" size={12} color="var(--cs-mute-2)" />
            </button>
          )}
        </CSCard>

        {/* BULL 경제 hero — 잔액+등급+EXP 통합 (CD MY탭 리디자인: 3카드→1카드). EXP충전은 기존 convOpen 모달 연결 */}
        <CSCard tone="ink" padded style={{ padding: 22, marginTop: 14, position: "relative", overflow: "hidden" }}>
          {/* 장착 캐릭터 — 우상단 오버사이즈(미장착=황둥이). 뽑기의 보상이 '매일 보는 내 화면'에 나타나는 자리(§14 애착축).
              158 → 130으로 줄였다: 158이면 콘텐츠를 약 130pt 침범해, 잔액을 피하려 준 우측 패딩
              탓에 9자리 잔액이 두 줄로 접혔다(2026-08-14 SE3 육안). */}
          <div style={{ position: "absolute", right: -6, top: -6, opacity: 0.95, pointerEvents: "none" }}>
            {!castLoading && <CastPortrait id={heroCastId} size={130} mood="happy" hideCaption style={{ background: "transparent" }} />}
          </div>
          <div style={{ position: "relative", zIndex: 2 }}>
            {/* 잔액 — 우상단 황둥이(130px, right:-6)가 콘텐츠를 약 100pt 침범한다.
                zIndex로 글자가 위에 오더라도 캐릭터 위에 숫자가 겹쳐 읽히지 않으므로
                상단 블록만 우측 패딩으로 비워 준다. divider 아래(등급·EXP 바)는
                캐릭터 하단이라 폭을 그대로 쓴다. */}
            <div style={{ paddingRight: 96 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <CSIcon name="coin" size={14} color="var(--cs-gold-on-ink)" />
                <span style={{ fontSize: 11, color: "var(--cs-gold-on-ink)", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700 }}>BULL 경제</span>
              </div>
              {/* 자릿수가 늘면 폰트를 줄여 한 줄을 지킨다 — SE3(375pt) 기준 가용 폭이 약 203pt라
                  40px 모노로는 9자("1,234,567")까지만 들어간다. nowrap으로 접힘 자체를 막고,
                  줄어든 폰트가 그 안에 맞도록 단계를 잡았다. */}
              <div className="num" style={{ fontSize: bullFontSize, fontWeight: 500, letterSpacing: "-0.04em", color: "var(--cs-gold-on-ink)", marginTop: 8, lineHeight: 1, whiteSpace: "nowrap" }}>
                {sk ? <Sk w={140} h={36} /> : bullText}
              </div>
              {/* 크레딧은 BULL과 별개 재화 — 있을 때만 숫자 아래에 따로 적는다 (아래 적립 줄과 같은 스타일) */}
              {!sk && creditBull > 0 && (
                <div style={{ fontSize: 12, color: "rgba(251,248,241,.65)", marginTop: 6 }}>
                  크레딧 <span className="num" style={{ color: "var(--cs-gold-on-ink)" }}>{won(creditBull)}</span> 별도
                </div>
              )}
              <div style={{ fontSize: 12, color: "rgba(251,248,241,.65)", marginTop: 6 }}>
                오늘 <span className="num" style={{ color: "var(--cs-gold-on-ink)" }}>+{won(me?.todayEarn)}</span> 적립 · 이번 달 <span className="num" style={{ color: "var(--cs-gold-on-ink)" }}>+{won(me?.monthEarn)}</span>
              </div>
            </div>
            {/* divider */}
            <div style={{ height: 1, background: "rgba(251,248,241,.14)", margin: "16px 0" }} />
            {/* 등급 + EXP */}
            <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}>
              {/* 조회 실패를 기본값으로 위장하지 않는다 (2026-08-02 결정) —
                  예전엔 me가 없으면 "송아지 Lv.1"을 그려서, 실제 Lv.7 사용자가 강등된 것처럼 보였다.
                  로딩 중이면 스켈레톤 · 실패면 "—". 다음 폴링에서 자동 복구되므로 재시도 버튼은 두지 않는다. */}
              <span style={{ fontSize: 14, fontWeight: 700, color: "var(--cs-accent-ink)" }}>현재 등급 · <span style={{ color: "var(--cs-gold-on-ink)" }}>{sk ? <Sk w={44} /> : (me?.grade?.label ?? "—")}</span>{me?.grade?.level != null ? ` Lv.${me.grade.level}` : ""}</span>
              <span className="num" style={{ fontSize: 13, color: "var(--cs-gold-on-ink)" }}>{won(me?.grade?.currentExp)} / {won(me?.grade?.nextExp)} EXP</span>
            </div>
            <div style={{ marginTop: 10, height: 6, borderRadius: 999, background: "rgba(251,248,241,.16)", overflow: "hidden" }}>
              <div style={{ width: `${Math.round((me?.grade?.progress ?? 0) * 100)}%`, height: "100%", borderRadius: 999, background: "var(--cs-gold-on-ink)" }} />
            </div>
            <div style={{ marginTop: 9, fontSize: 12, color: "rgba(201,207,196,.9)" }}>
              다음 레벨까지 {won((me?.grade?.nextExp ?? 0) - (me?.grade?.currentExp ?? 0))} EXP — 활동할수록 황소가 자랍니다
            </div>
            {/* 액션 — 결제 충전과 BULL→EXP 교환을 문구로 명확히 가른다. */}
            <div style={{ marginTop: 18, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              <button onClick={() => navigate('/store')} style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6, padding: "11px 16px", borderRadius: 999, background: "var(--cs-gold)", color: "var(--cs-accent-ink)", fontSize: 14, fontWeight: 800 }}>
                <CSIcon name="coin" size={15} />
                {/* /store가 파는 것은 크레딧(유상) — BULL(무상 활동 보상)이 아니다. 스토어·뽑기 화면 표기와 통일 */}
                크레딧 충전
              </button>
              <button onClick={() => setConvOpen(true)} style={{ cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6, padding: "11px 18px", borderRadius: 999, background: "var(--cs-gold)", color: "var(--cs-accent-ink)", fontSize: 14, fontWeight: 800 }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" /></svg>
                EXP 교환
              </button>
              {/* 죽은 UI 2개('사용처 보기' onClick 없음 · '적립 내역' 라벨) → 실기능 1개로 통합 (2026-08-17)
                  — 유료 결제 기록을 사용자가 확인할 유일한 화면이라 CS·환불 분쟁의 1차 방어선이다 */}
              <button onClick={() => navigate('/store/history')} style={{ cursor: "pointer", padding: "11px 16px", borderRadius: 999, background: "rgba(251,248,241,.12)", color: "var(--cs-accent-ink)", fontSize: 14, fontWeight: 700 }}>충전 내역</button>
            </div>
            <div style={{ marginTop: 10, fontSize: 11, color: "rgba(201,207,196,.75)" }}>BULL 1:1 교환 · 하루 200 EXP까지</div>
          </div>
        </CSCard>

        {/* 내 활동 (CD MY탭 리디자인: 2열 그리드) — 황소컬렉션·행동챌린지. 서브카피는 실데이터(수집수·챌린지 요약).
            황소 컬렉션 = 업적 갤러리(/collection). 예전 "23 / 60 수집"은 시안 리터럴이라 모든 사용자에게 같은
            숫자가 떴다(2026-09-11 발견). 0cbf6954가 우선 고정 문구("BULL 업적·수집 쇼케이스")로 막았고,
            /collection이 업적 실데이터로 바뀌면서 같은 훅(useAchievementGallery)의 획득/전체로 교체(09-12).
            미로그인·로딩·실패 땐 숫자 대신 "업적 갤러리" — 0을 찍으면 "하나도 못 땄다"는 거짓이 된다. */}
        <div style={{ marginTop: 20, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 700 }}>내 활동</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <CSCard padded onClick={() => navigate('/collection')} style={{ padding: 16, cursor: 'pointer' }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: 'var(--cs-bull)', color: 'var(--cs-accent-ink)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <CSIcon name="bull" size={20} stroke={1.8} />
            </div>
            <div style={{ marginTop: 12, fontSize: 15, fontWeight: 700, letterSpacing: '-0.02em' }}>황소 컬렉션</div>
            <div className={achGallery && user && !achError ? 'num' : undefined} style={{ marginTop: 4, fontSize: 12.5, color: 'var(--cs-mute)' }}>
              {achGallery && user && !achError ? `${achGallery.got} / ${achGallery.total} 업적` : '업적 갤러리'}
            </div>
          </CSCard>
          <CSCard padded onClick={() => navigate('/challenge-board')} style={{ padding: 16, cursor: 'pointer' }}>
            <div style={{ width: 40, height: 40, borderRadius: 10, background: 'var(--cs-gold-soft)', color: 'var(--cs-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}><CSIcon name={chTrack?.icon} size={20} /></div>
            <div style={{ marginTop: 12, fontSize: 15, fontWeight: 700, letterSpacing: '-0.02em' }}>기록 미션</div>
            <div style={{ marginTop: 4, fontSize: 12.5, color: 'var(--cs-mute)', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{chSummary}</div>
          </CSCard>
        </div>

        {/* 코스메틱 진입 (효신님 결정 2026-06-14: 모의투자→MY 이동). §11 페르소나 6:0 · design doc §3.2 */}
        <div style={{ marginTop: 14, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 700 }}>코스메틱</div>
        <CSCard padded={false} style={{ padding: "0 16px" }}>
          {[
            { icon: <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z" /></svg>, t: '카드 뽑기', to: '/gacha' },
            { icon: <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" /><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" /><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" /></svg>, t: '카드 컬렉션', to: '/cards' },
            { icon: <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="3" x2="21" y1="22" y2="22" /><line x1="6" x2="6" y1="18" y2="11" /><line x1="10" x2="10" y1="18" y2="11" /><line x1="14" x2="14" y1="18" y2="11" /><line x1="18" x2="18" y1="18" y2="11" /><polygon points="12 2 20 7 4 7" /></svg>, t: '공시관', to: '/hall' },
          ].map((m, i, arr) => (
            <CSRow key={m.to} divider={i < arr.length - 1}
              left={<span style={{ color: "var(--cs-accent)", display: "flex" }}>{m.icon}</span>}
              title={m.t} right={<CSIcon name="arrow" size={14} color="var(--cs-mute-2)" />}
              onClick={() => navigate(m.to)}
            />
          ))}
        </CSCard>

        {/* 자산·성향 도구와 실험실은 로그인 여부와 무관하게 제공한다. */}
        <CSCard padded={false} style={{ padding: "0 16px", marginTop: 14 }}>
          {/* divider={false} — 행이 하나뿐인 카드라 기본 divider(true)를 그대로 두면
              카드 안 마지막에 갈 곳 없는 줄이 남는다(효신님 실기 지적 2026-09-08 · §G-2). */}
          <CSRow
            divider={false}
            left={<CSIcon name="wallet" size={18} color="var(--cs-accent)" />}
            title="자산·성향 도구" sub="자산 입력 · 가계부 · 목표 · 투자 자아 카드"
            right={<CSIcon name="arrow" size={14} color="var(--cs-mute-2)" />}
            onClick={() => navigate('/finance')}
          />
        </CSCard>

        <div style={{ marginTop: 14, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", fontWeight: 700 }}>실험실</div>
        <div style={{ padding: "0 4px 8px", fontSize: 12, color: "var(--cs-mute)" }}>가정을 바꿔 미래 자산을 살펴봐요</div>
        <CSCard padded={false} style={{ padding: "0 16px" }}>
          {[
            { icon: 'chart', title: '미래가격 계산기', sub: '저축액·기간·수익률을 바꿔 미래 자산 계산', to: '/future-price' },
            { icon: 'wallet', title: '자산 시뮬레이션', sub: '자산·부채를 입력하거나 예시로 10년 후 살펴보기', to: '/play' },
          ].map((item, index) => (
            <CSRow key={item.to} divider={index === 0}
              left={<CSIcon name={item.icon} size={18} color="var(--cs-accent)" />}
              title={item.title} sub={item.sub}
              right={<CSIcon name="arrow" size={14} color="var(--cs-mute-2)" />}
              onClick={() => navigate(item.to)}
            />
          ))}
        </CSCard>

        {/* 진단 진입 — MY탭에 투자 성향 진단 자체가 없던 갭 fix (효신님 SE3 육안 2026-07-02) */}
        <div style={{ marginTop: 14, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 700 }}>진단</div>
        <CSCard padded={false} style={{ padding: "0 16px" }}>
          {[
            { icon: <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88" /></svg>, t: '머니타입 진단', to: '/mbti/diagnose' },
            { icon: <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3v18h18" /><path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" /></svg>, t: '위험 성향 진단 · 권장 배분', to: '/risk' },
          ].map((m, i, arr) => (
            <CSRow key={m.to} divider={i < arr.length - 1}
              left={<span style={{ color: "var(--cs-accent)", display: "flex" }}>{m.icon}</span>}
              title={m.t} right={<CSIcon name="arrow" size={14} color="var(--cs-mute-2)" />}
              onClick={() => navigate(m.to)}
            />
          ))}
        </CSCard>

        {/* 설정 메뉴 (실작동) */}
        <div style={{ marginTop: 14, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 700 }}>설정</div>
        <CSCard padded={false} style={{ padding: "0 16px" }}>
          {settingMenu.map((m, i) => (
            <CSRow key={i} divider={i < settingMenu.length - 1}
              left={<CSIcon name={m.i} size={18} color="var(--cs-mute)" />}
              title={m.t} sub={m.sub} right={<CSIcon name="arrow" size={14} color="var(--cs-mute-2)" />}
              onClick={m.onClick}
            />
          ))}
        </CSCard>

        {/* 준비 중 (CD MY탭: 미배선 항목 dim 그룹 분리) */}
        <div style={{ marginTop: 14, padding: "0 4px 4px", fontSize: 11.5, color: "var(--cs-mute)", letterSpacing: "0.08em", textTransform: "uppercase", fontWeight: 700 }}>준비 중</div>
        <CSCard padded={false} style={{ padding: "0 16px", opacity: 0.5 }}>
          {MENU.map((m, i) => (
            <CSRow key={i} divider={i < MENU.length - 1}
              left={<CSIcon name={m.i} size={18} color="var(--cs-mute)" />}
              title={m.t}
              right={<span style={{ fontSize: 11, fontWeight: 700, color: "var(--cs-mute)", background: "var(--cs-surface-2)", borderRadius: 999, padding: "3px 9px" }}>준비 중</span>}
              onClick={m.onClick}
            />
          ))}
        </CSCard>

        {/* 계정 삭제 — 로그인 상태에서만. 설정 목록에 섞지 않고 맨 아래 회색 링크로 분리한다
            (웹 마이페이지와 같은 배치 · 오폭 방지). App Store 5.1.1(v) 요구 경로. */}
        {user && (
          <div style={{ textAlign: "center", margin: "26px 0 4px" }}>
            <button
              type="button"
              onClick={() => setDeleteOpen(true)}
              style={{
                background: "transparent", border: "none", color: "var(--cs-mute)",
                fontSize: 11.5, textDecoration: "underline", cursor: "pointer", fontFamily: "inherit",
                padding: 6,
              }}
            >
              계정 삭제
            </button>
          </div>
        )}

        {/* 개발자용 숨은 제스처라 버튼으로 노출하지 않는다(스크린리더에 목적 없는 컨트롤을 만들지 않기 위해). */}
        <div onClick={tapVersion}
          style={{ marginTop: 18, padding: 4, fontSize: 10.5, color: "var(--cs-mute)", textAlign: "center", fontFamily: "var(--cs-font-mono)", userSelect: "none" }}>
          sotda.com{appVersion ? ` · ${appVersion}` : ''}{showBuild ? ` · 빌드 ${__BUILD_TIME__}` : ''}
        </div>
      </div>

      {/* #7 BULL → EXP 전환 모달 (sheet) */}
      {convOpen && (
        <CSModal open onClose={() => setConvOpen(false)} title="BULL → 경험치 교환" sheet>
          <div style={{ padding: '4px 0 8px' }}>
            <div style={{ fontSize: 12, color: 'var(--cs-mute)', marginBottom: 14, lineHeight: 1.5 }}>
              활동 BULL을 1:1로 EXP로 바꿔요. 충전·구독분은 제외돼요.<br />
              <b style={{ color: 'var(--cs-ink)' }}>전환 가능 {won(activeBull)} BULL</b> · 오늘 남은 <b style={{ color: 'var(--cs-accent)' }}>{dailyRem == null ? '— ' : `${won(dailyRem)} `}EXP</b>
            </div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
              {[50, 100, 200].map((v) => {
                const dis = v > maxConv;
                return (
                  <button key={v} disabled={dis} onClick={() => setConvAmt(v)}
                    style={{ flex: 1, padding: '11px 0', borderRadius: 'var(--cs-r-md)', border: `1px solid ${convAmt === v ? 'var(--cs-accent)' : 'var(--cs-line)'}`, background: convAmt === v ? 'var(--cs-accent)' : 'var(--cs-surface)', color: dis ? 'var(--cs-mute-2)' : convAmt === v ? 'var(--cs-accent-ink)' : 'var(--cs-ink)', fontSize: 14, fontWeight: 700, fontFamily: 'var(--cs-font-mono)', cursor: dis ? 'not-allowed' : 'pointer', opacity: dis ? 0.45 : 1 }}>
                    {v}
                  </button>
                );
              })}
            </div>
            <div style={{ fontSize: 13, textAlign: 'center', marginBottom: 14 }}>
              <span className="num" style={{ fontWeight: 700 }}>{won(convAmt)} BULL</span>
              <span style={{ color: 'var(--cs-mute)', margin: '0 6px' }}>→</span>
              <span className="num" style={{ fontWeight: 700, color: 'var(--cs-accent)' }}>+{won(convAmt)} EXP</span>
            </div>
            {convMsg && (
              <div style={{ fontSize: 12.5, textAlign: 'center', marginBottom: 10, fontWeight: 600, color: convMsg.startsWith('✓') ? 'var(--cs-rise)' : 'var(--cs-fall)' }}>{convMsg}</div>
            )}
            <CSBtn variant="primary" size="md" full disabled={converting || convAmt <= 0 || convAmt > maxConv} onClick={doConvert}>
              {converting ? '전환 중…' : dailyRem == null ? '한도를 불러오는 중…' : maxConv <= 0 ? '전환 가능한 BULL 없음' : `${won(convAmt)} BULL 전환`}
            </CSBtn>
            <div style={{ fontSize: 10.5, color: 'var(--cs-mute)', textAlign: 'center', marginTop: 9 }}>전환한 BULL은 돌려받을 수 없어요</div>
          </div>
        </CSModal>
      )}

      {/* 계정 삭제 시트 — 성공 시 로그아웃까지 시트가 처리하고, 캐시 정리·이동만 여기서 한다 */}
      {/* 프로필 편집 허브 — iOS 설정식 2행. §G: 테두리 없이 divider 1줄 · 그림자 없음.
          닉네임 행은 이 시트를 닫고 기존 NicknameSheet로 넘긴다(NicknameSheet는 닉네임 전용 그대로 둔다). */}
      <CSModal open={editOpen} onClose={() => setEditOpen(false)} title="프로필 편집" sheet>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {[
            { k: 'cast', label: '캐릭터', value: companionSummary,
              go: () => { setEditOpen(false); navigate('/cards?focus=base'); } },
            { k: 'nick', label: '닉네임', value: nick,
              go: () => { setEditOpen(false); setNickOpen(true); } },
          ].map((row, i) => (
            <button key={row.k} type="button" onClick={row.go}
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 2px', background: 'transparent',
                border: 0, borderTop: i ? '1px solid var(--cs-line)' : 0, textAlign: 'left', cursor: 'pointer', color: 'inherit' }}>
              <span style={{ fontSize: 14, fontWeight: 600, flexShrink: 0 }}>{row.label}</span>
              <span style={{ flex: 1, minWidth: 0, textAlign: 'right', fontSize: 12.5, color: 'var(--cs-mute)',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.value}</span>
              <CSIcon name="arrow" size={12} color="var(--cs-mute-2)" />
            </button>
          ))}
        </div>
      </CSModal>

      <NicknameSheet
        open={nickOpen}
        onClose={() => setNickOpen(false)}
        current={nick}
        onChanged={(n) => {
          // me 캐시를 다시 불러야 헤더·프로필 카드 닉네임이 즉시 갱신된다
          qc.invalidateQueries({ queryKey: ['me'] });
          showSuccess(`닉네임이 '${n}'(으)로 바뀌었어요`);
        }}
      />

      <DeleteAccountSheet
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onDeleted={() => {
          setDeleteOpen(false);
          // 로그아웃과 같은 뒷정리 — 안 비우면 삭제된 계정의 프로필·BULL이 화면에 남는다
          qc.removeQueries({ queryKey: ['me'] });
          showSuccess('계정이 삭제됐어요');
          navigate('/');
        }}
      />

      {/* 차단한 사용자 관리 모달 (App Store 1.2 차단 해제 경로) */}
      {blockOpen && (
        <CSModal open onClose={() => setBlockOpen(false)} title="차단한 사용자" sheet>
          <div style={{ padding: '4px 0 8px' }}>
            {blockedList.length === 0 ? (
              <div style={{ padding: '20px 0', textAlign: 'center', color: 'var(--cs-mute)', fontSize: 13 }}>
                차단한 사용자가 없어요
              </div>
            ) : (
              blockedList.map((b) => (
                <div key={b.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 2px', borderBottom: '1px solid var(--cs-line)' }}>
                  <span style={{ fontSize: 13.5, color: 'var(--cs-ink)' }}>{b.nickname}</span>
                  <button onClick={() => handleUnblock(b.id)}
                    style={{ border: '1px solid var(--cs-line-2)', borderRadius: 8, padding: '6px 14px', background: 'transparent', color: 'var(--cs-ink-2)', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' }}>
                    차단 해제
                  </button>
                </div>
              ))
            )}
            <div style={{ fontSize: 10.5, color: 'var(--cs-mute)', textAlign: 'center', marginTop: 12 }}>
              차단하면 그 사용자의 글·댓글이 보이지 않아요
            </div>
          </div>
        </CSModal>
      )}
    </div>
  );
}
